import { BaseFeatureItemDto } from '../../../shared/modules/base/dtos/base-feature-item.dto';
import { TenantFeatureItemTypeEnum } from '../enums/tenant-feature-item-type.enum';

/**
 * Tenant feature item DTO
 */
export class TenantFeatureItemDto extends BaseFeatureItemDto {
	type!: TenantFeatureItemTypeEnum;
}
